import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

const usePushStore = createWithEqualityFn(
  (set) => ({
    pushes: [],
    addPush: (push) =>
      set((state) => ({
        pushes: [...state.pushes, { ...push, id: Date.now() }],
      })),
    removePush: (id) =>
      set((state) => ({
        pushes: state.pushes.filter((push) => push.id !== id),
      })),
  }),
  shallow
);

export default usePushStore;